import httpClient from '@/api/httpClient'
import { defineStore } from 'pinia'
import { useMessagesStore } from '@/stores/messages'

const STORY_SOURCE_TYPE = 'Story'
const MEDIUM_SOURCE_TYPE = 'Medium'

export const useExportFormatsStore = defineStore('exportFormats', {
  state: () => ({
    exportFormats: [],
    fetchInitiated: false,
  }),

  getters: {
    forStories({ exportFormats }) {
      return exportFormats.filter(({ source_type }) => source_type == STORY_SOURCE_TYPE)
    },

    forMedia({ exportFormats }) {
      return exportFormats.filter(({ source_type }) => source_type == MEDIUM_SOURCE_TYPE)
    },

    allAsObject({ exportFormats }) {
      return exportFormats.reduce((obj, exportFormat) => {
        obj[exportFormat.name] = exportFormat.id
        return obj
      }, {})
    },

    forIds: ({ exportFormats }) => (ids) => {
      return exportFormats.filter(exportFormat => ids.includes(exportFormat.id))
    },

    fieldsOnlyAsObject({ exportFormats }) {
      return exportFormats.filter(
        format => !format.master_template
      ).reduce((obj, exportFormat) => {
        obj[exportFormat.name] = exportFormat.id
        return obj
      }, {})
    },

    forBatchExport({ exportFormats }) {
      return exportFormats.filter(
        format => format.batch_export && format.source_type === STORY_SOURCE_TYPE
      )
    },

    forBatchExportAsObject({ exportFormats }) {
      return exportFormats.filter(
        format => format.batch_export && format.source_type === STORY_SOURCE_TYPE
      ).reduce((obj, exportFormat) => {
        obj[exportFormat.name] = exportFormat.id
        return obj
      }, {})
    }
  },

  actions: {
    async fetch() {
      this.fetchInitiated = true

      return httpClient.get('/api/internal/export_formats')
        .then(response => {
          this.exportFormats = response.data.export_formats
        })
        .catch((err) => {
          useMessagesStore().smartAdd(err)
        })
    },

    async fetchOnce() {
      if (this.fetchInitiated) return Promise.resolve()

      this.fetch()
    },

    async destroy(id) {
      return httpClient.delete(`/api/internal/export_formats/${id}`)
        .then(() => {
          this.exportFormats = this.exportFormats.filter(ef => ef.id !== id)
          useMessagesStore().addNotice('Export format deleted')
        })
        .catch(err => {
          useMessagesStore().smartAdd(err)
        })
    }
  },
})
